import {Component, OnInit} from '@angular/core';
import {GuideService} from 'app/services/guide.service';

const
  SCHEMA_FILENAME: String = '../../assets/schema/guide.json';

@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.css']
})
export class CmsComponent implements OnInit {

  constructor(private guideService: GuideService) {
  }

  ngOnInit() {
    this.guideService.loadGuideJsonFromBackend().then(json => {
      // do something
    });
  }


}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/cms/cms.component.ts